export default "__VITE_ASSET__Cbnm3CkH__"